// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1579618889564
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = ./src/components/Header/Header.scss
// module chunks = 0